export default "__VITE_ASSET__ykfsDkxl__"